import {
  Box,
  HStack,
  RadioGroupProps,
  useRadio,
  useRadioGroup,
  UseRadioProps,
} from '@chakra-ui/react';
import React from 'react';

export interface RadioButtonGroupProps
  extends Pick<RadioGroupProps, 'isDisabled' | 'defaultValue' | 'value'> {
  options: string[];
  name: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

// TODO: implementation of this may be changed depending on how
// we end up handling forms on the gatsby side
const RadioButton: React.FC<UseRadioProps> = (props) => {
  const { getInputProps, getCheckboxProps } = useRadio(props);

  const input = getInputProps();
  const checkbox = getCheckboxProps();

  return (
    <Box as="label">
      <input {...input} />
      <Box
        {...checkbox}
        cursor="pointer"
        borderWidth="1px"
        borderRadius="sm"
        boxShadow="none"
        border="1px solid #CFCFCF"
        marginX=".25rem"
        _checked={{
          color: 'grey',
          borderColor: '#CFCFCF',
          background: 'white',
          _before: {
            width: '10px',
            height: '10px',
          },
          _hover: {
            bg: 'none',
            borderColor: '#CFCFCF',
          },
        }}
        background="white"
        // _focus={{
        //   boxShadow: 'outline',
        // }}
        px={3}
        py={2}
      >
        {props.children}
      </Box>
    </Box>
  );
};

const RadioButtonGroup: React.FC<RadioButtonGroupProps> = ({
  options = [],
  defaultValue,
  isDisabled,
  name,
  onChange,
  value,
}) => {
  const handleChange = React.useCallback(
    (value: string) => {
      onChange?.({ target: { name, value } } as any);
    },
    [name, onChange],
  );
  const { getRootProps, getRadioProps } = useRadioGroup({
    name,
    defaultValue,
    onChange: handleChange,
    isDisabled,
    value,
  });

  const group = getRootProps();

  return (
    <HStack {...group}>
      {options.map((value) => {
        const radio = getRadioProps({ value });
        return (
          <RadioButton key={value} {...radio}>
            {value}
          </RadioButton>
        );
      })}
    </HStack>
  );
};

export default RadioButtonGroup;
